<template type="text/template" id="template_pagination">
    <section class="pages-wrap" v-show="pageInfo.total>pageInfo.pagenum">
        <ul class="pagination">
            <li :class="{'disabled': pageInfo.current == 1}"><a href="javascript:;" @click="clickCurrent(pageInfo.current - 1)">
                <img v-show="pageInfo.current != 1" src="../../assets/images/arrow_left_active.png">
                <img v-show="pageInfo.current == 1" src="../../assets/images/arrow_left_disable.png"> 
                </a></li>
            <li v-for="p in getList"  :class="{'active': pageInfo.current == p.val}" >
                <a href="javascript:;" v-if="pageInfo.current == p.val" :style="{backgroundColor:pageInfo.skin , borderColor:pageInfo.skin}" @click="clickCurrent(p.val)"> {{ p.text }} </a>
                <a href="javascript:;" v-else  @click="clickCurrent(p.val)"> {{ p.text }} </a>
            </li>
            <li :class="{'disabled': pageInfo.current == page}"><a href="javascript:;" @click="clickCurrent(pageInfo.current + 1)">
                <img v-show="pageInfo.current != page" src="../../assets/images/arrow_right_active.png">
                <img v-show="pageInfo.current == page" src="../../assets/images/arrow_right_disable.png"></a></li>
            <li>共{{page}}页</li>
        </ul>
    </section>
</template>
<script>
import Vue from 'vue'
export default {
    props:['pageInfo'],
    computed: {
        page:function() {
            return Math.ceil(this.pageInfo.total / this.pageInfo.pagenum);
        },
        getList:function() {
          const showNum = 2;
          const setNum = 2;
          const len = this.page;
          const current = this.pageInfo.current;
          let list = [];
          let frontArr = [], middleArr = [], endArr = [];
          if (len < (showNum * 2) + 1) {
            for (let i = 1;  i <= len; i++) {
              list.push({
                text: i,
                val: i 
              });
            }
            return list;
          } else {
              for (let j = 1; j <= showNum; j++) {
                frontArr.push({text: j, val: j});
                endArr.push({text: len - showNum + j, val: len - showNum + j});
              }
              for (let k = current - setNum; k <= current + setNum; k++ ) {
                if (k > showNum && k <= len - showNum ) {
                  middleArr.push({text: k, val: k});
                }
              }
              if (middleArr.length != 0) {
                if (middleArr[0].val > frontArr[showNum - 1].val + 1) {
                  middleArr.unshift({text: '...', val: frontArr[showNum - 1] + 1})
                }
                if (middleArr[middleArr.length - 1].val < endArr[0].val - 1) {
                  middleArr.push({text: '...', val: middleArr[middleArr.length - 1].val + 1});
                }
              } else if (frontArr[showNum - 1].val + 1 < endArr[0].val){
                middleArr.push({text: '...', val: frontArr[showNum - 1] + 1});
              }
              list = list.concat(frontArr,middleArr,endArr);
              return list;
          }
        }
    },
    created:function (argument) {
        console.log(this.pageInfo)
    },
    methods: {
        clickCurrent: function(idx) {
            if( this.pageInfo.current != idx && idx > 0 && idx < this.page + 1) {
                this.pageInfo.current = idx;
                this.$emit('change',this.pageInfo.current);
            }
        }
    }
}
</script>
<style scoped>
.pages-wrap {
    text-align: center;
}
.pagination {
    padding: 0 10px;
    border-radius: 4px;
    height: 50px;
    display: flex;
    align-items: center;
    font-size: 16px;
    color: #333;
    font-weight: 500;
}
.pagination>li {
   display: inline;
}
ul>li {
    margin: 0;
}
.pagination>.active>a, .pagination>.active>a:hover, .pagination>.active>span,  .pagination>.active>span:hover {
    z-index: 3;
    color: #fff;
    cursor: default;
    background-color: #337ab7;
    border-color: #337ab7;
}
.pagination>.disabled>a, .pagination>.disabled>a:hover, .pagination>.disabled>span, .pagination>.disabled>span:hover {
    color: #777;
    cursor: not-allowed;
}
.pagination>li>a:hover,.pagination>li>span:hover {
    z-index: 2;
    color: #fd4e7f;
    /* background-color: #eee; */
 }
  .pagination>li>a, .pagination>li>span {
    font-size: 16px;
    display: inline-block;
    width: 24px;
    height: 24px;
    margin-right:15px;
    border-radius:50% 50%;
    line-height: 24px;
    color: #000;
    text-align: center;
    text-decoration: none;
    float: left;
 }

 .pagination>li>a>img {
     width: 16px;
     height: 16px;
    vertical-align: middle;
 }

</style>


// WEBPACK FOOTER //
// src/components/pagination/pagination.vue